import dayjs from 'dayjs';

// Default number of intervals on the time axis (so there are count + 1 ticks).
const DEFAULT_TICK_COUNT = 6;

interface ReplayTick {
  // Position along the timeline, 0 (start) to 1 (end).
  fraction: number;
  label: string;
}

/**
 * Evenly-spaced ticks for the Gantt time axis. Labels are time-of-day for a
 * single-day order; when the order spans more than one calendar day the date is
 * included so overnight/multi-day windows aren't ambiguous.
 */
export function computeReplayTicks(
  minTimeMs: number,
  maxTimeMs: number,
  count: number = DEFAULT_TICK_COUNT,
): ReplayTick[] {
  if (maxTimeMs <= minTimeMs) return [];

  const spansMultipleDays = !dayjs.tz(minTimeMs).isSame(dayjs.tz(maxTimeMs), 'day');
  const format = spansMultipleDays ? 'MMM D, h:mm A' : 'h:mm A';

  return Array.from({ length: count + 1 }, (_, index) => {
    const fraction = index / count;

    return {
      fraction,
      label: dayjs.tz(minTimeMs + fraction * (maxTimeMs - minTimeMs)).format(format),
    };
  });
}
